import { types } from "mobx-state-tree";
import { IInput } from "../../../utils/common-interface";

export const ErrorModel = types
  .model("ErrorModel", {
    tigger: types.optional(types.boolean, false),
    code: types.optional(types.string, ""),
    title: types.optional(types.string, ""),
    message: types.optional(types.string, ""),
    technicalStack: types.optional(types.string, ""),
  })
  .actions((self: any) => ({
    setTigger: (tigger: boolean) => {
      self.tigger = tigger;
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IErrorModel = typeof ErrorModel.Type;
